import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Activities from "../pages/activities/page";
import Courses from "../pages/courses/page";
import Mentorship from "../pages/mentorship/page";
import Outreach from "../pages/outreach/page";
import Donation from "../pages/donation/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/activities",
    element: <Activities />,
  },
  {
    path: "/courses",
    element: <Courses />,
  },
  {
    path: "/mentorship",
    element: <Mentorship />,
  },
  {
    path: "/outreach",
    element: <Outreach />,
  },
  {
    path: "/donation",
    element: <Donation />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;